// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3HlRK","container":"styles_container__2-yJO","title":"styles_title__33s3c","wrapper":"styles_wrapper__2iTIi","answer":"styles_answer__3saXT"};